import api from './client';

export const fetchOverrides = (workspaceId) =>
  api.get(`/admin/workspaces/${workspaceId}/feature_overrides`);

export const saveOverrides = (workspaceId, changes) =>
  api.put(`/admin/workspaces/${workspaceId}/feature_overrides`, { changes });

export const grantOverride = ({ clientId, subFeatureId, state, reason }) =>
  api.post('/admin/feature_overrides', {
    client_id: clientId,
    sub_feature_id: subFeatureId,
    state,
    reason,
  });
